import {Card, CardContent} from "@mui/material";
import Typography from "@mui/material/Typography";

function BalanceCard({title, amount}) {
    return (
        <Card variant="outlined" sx={{borderRadius: 2, height: "100%"}}>
            <CardContent sx={{padding: '0.75rem 1rem', '&:last-child': {paddingBottom: '0.75rem'}}}>
                <Typography color="textSecondary" variant="caption">{title}</Typography>
                <Typography component="div" sx={(theme) => ({fontFamily: theme.brand.fonts.display, fontSize: "1.5rem", lineHeight: 1.1, marginTop: 0.25})}>
                    {amount}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default BalanceCard;
